// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.genericResponse.BaseIssue
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class BaseIssue {
  static createBaseIssue(errorMessages, isValid) {
    const retVal = new BaseIssue();
    retVal.initBaseIssue(errorMessages, isValid);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createBaseIssue factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadg.BaseIssue";
  }
  initFromJson(json, deserializeContext) {
    this.initBaseIssue(json.errorMessages != null ? json.errorMessages : null, json.isValid);
  }
  initBaseIssue(errorMessages, isValid) {
    this._errorMessages = errorMessages;
    this._isValid = isValid;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["errorMessages"] = this._errorMessages;
    retVal["isValid"] = this._isValid;
    return retVal;
  }
  get errorMessages() {
    return this._errorMessages;
  }
  set errorMessages(value) {
    this._errorMessages = value;
  }
  get isValid() {
    return this._isValid;
  }
  set isValid(value) {
    this._isValid = value;
  }
}
//# sourceMappingURL=BaseIssue.js.map
